var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderTree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "folder-tree",
    d: "M6.667,5.333V4.667H1.333V10a2,2,0,0,0,2,2H6.667V10.667a2,2,0,0,1,2-2h1.724a1.324,1.324,0,0,1,.943.391l.943.943H14a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H8.667a2,2,0,0,1-2-2v-.667H3.333A3.337,3.337,0,0,1,0,10V.667a.667.667,0,0,1,1.333,0V3.333H6.667V2a2,2,0,0,1,2-2h1.724a1.324,1.324,0,0,1,.943.391l.943.943H14a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H8.667A2,2,0,0,1,6.667,5.333Z",
    fill: "#707070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderTree);
export default __webpack_public_path__ + "static/media/folder-tree.f4687184734fd697073476dd8d3df940.svg";
export { ForwardRef as ReactComponent };